import * as c from "../actions/constants";

const initialState = {
  activeHost: null,
  activeServer: null,
  activeOrganization: null,
  activePackage: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case c.ACTIVE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/activeReducer.js